import store from '@polleverywhere/redux'
import rootFolders from '@polleverywhere/redux/slices/explorer/root_folders'
import { slice as activitiesSlice } from '../apps/activities/slice'
import { slice as appSlice } from '../slices/app'
import listenToSelector from '../util/listen_to_selector'

export default function ActivitiesNavDispatcher (app) {
  const { role } = store.getState()[appSlice.name]

  if (['presenter', 'slideware', 'agave'].includes(role)) {
    // Update the main app activePath when the activities page/view changes
    listenToSelector((state) => {
      const activitiesState = state[activitiesSlice.name] || {}
      const { ready, page: rootPage } = state[appSlice.name]
      const { page, view } = activitiesState
      return {
        ready,
        rootPage,
        appPage: page,
        appView: view
      }
    }, ({ ready, rootPage, appPage, appView }) => {
      // Only update if the root is using the activitiesSlice
      if (ready && rootPage === 'activities') {
        app.activePath = [rootPage, appPage, appView].join('/')
      }
    }, (oldState, newState) => {
      // comparator
      return JSON.stringify(oldState) === JSON.stringify(newState)
    })

    app.addEventListener('l1-activated', (e) => {
      const { route } = e.detail
      if (route === 'activities') {
        store.dispatch(activitiesSlice.pageUpdated('activities'))
        store.dispatch(activitiesSlice.activityUpdated(null))
      }
    })

    app.addEventListener('l2-activated', (e) => {
      const { l1Page, route } = e.detail
      if (l1Page === 'activities') {
        const [page, view] = route.split('/')

        // set folder to root
        const rootFolder = rootFolders()[view]
        store.dispatch(activitiesSlice.folderUpdated(rootFolder))
        store.dispatch(activitiesSlice.activityUpdated(null))
        store.dispatch(activitiesSlice.viewUpdated(view))
        store.dispatch(activitiesSlice.pageUpdated(page))
      }
    })
  }
}
